import type { CustomAttribute, Primitive } from "@similarweb/sw-track";

import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import type { EmailTrackingEntityType } from "app/pages/sales-intelligence/services/enums";
import type { SignalsDigestParams } from "app/pages/sales-intelligence/sub-modules/signals/types";
import { getSignalsDigestParams } from "app/pages/sales-intelligence/sub-modules/signals/utils/signalsDigest";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { allTrackers } from "app/services/track/track";

type TrackingURLParams = SignalsDigestParams & {
    template: "email_signals" | "company_signal_emails";
};

export type PageViewTrackingParams<T = Record<string, unknown>, P = Record<string, unknown>> = P & {
    toParams: TrackingURLParams & T;
    toState: IRouterState;
};

function createEmailTrackingService(track: TrackFn) {
    const trackEmailClickEvent = (attributes: Record<CustomAttribute, Primitive>): void => {
        track("email digest", "click", "email click", attributes);
    };

    return {
        trackSignalsDigestEmail(entityType: EmailTrackingEntityType, params: TrackingURLParams): void {
            const { template } = params;
            const { digestType, signalSubType, domain, signalId } = getSignalsDigestParams(params);

            if (!["email_signals", "company_signal_emails"].includes(template)) {
                return;
            }

            const digestTypeAttribute: Record<CustomAttribute, Primitive> = digestType
                ? {
                      email_alert_frequency: digestType,
                  }
                : {};

            trackEmailClickEvent({
                ...digestTypeAttribute,
                entity_type: entityType,
                clicked_signal: signalSubType,
                template,
                signalId,
                domain: domain ?? "",
            });
        },
    };
}

const emailTrackingService = createEmailTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default emailTrackingService;
